<script setup lang="ts">
import useDomainConsent from '@scripts/composables/use-domain-consent.js'
import Consent from '@components/Consent.vue'

const props = defineProps<{
    object: string
}>()

const attributes = Object.fromEntries([
    ...props.object
        .matchAll(/(src|width|height)="([^"]*)"/g)
        .map((match) => [match[1], match[2]]),
])

const aspectRatio =
    attributes?.width && attributes?.height
        ? `${attributes.width} / ${attributes.height}`
        : '16 / 9'

const { isEnabled, enable, domain } = useDomainConsent(attributes.src)
</script>

<template>
    <Consent
        :enabled="isEnabled"
        :aspect-ratio="aspectRatio"
        :text="`Dieser Inhalt wird von ${domain} geladen.`"
        @consent="enable"
    >
        <div
            v-html="props.object"
            class="contents"
        ></div>
    </Consent>
</template>
